<template>
  <div>
    <div class="row">
      <div class="col-12 mt-2 mb-2">
        <b class>Product Details</b>
      </div>
    </div>
    <div class="row">
      <div
        v-if="!product.offerLines"
        class="col-md-12 content-list mb-2"
      >
        <b>Product:</b>
        <span>{{ product.name.trim() }}</span>
      </div>
      <div
        v-else
        class="col-10 content-list mb-2"
      >
        <div>
          <b>
            {{ product.name.trim() }}
            <br>
            <small
              v-for="(offerline, offerlineIndex) in product.offerLines"
              :key="offerline.id"
            >
              ({{ offerline.quantity }}) {{ offerline.name.trim() }}
              <i
                v-if="offerlineIndex + 1 != product.offerLines.length"
              >,</i>
            </small>
          </b>
        </div>
      </div>
      <hr>
    </div>
    <div class="row">
      <div class="col-md-12 content-list mb-2">
        <b>Price:</b>
        <div
          v-if="product.totalPrice || product.totalPrice === 0"
          class="ml-3 w-100"
        >
          <span v-if="!priceOverriden">
            {{ $n(product.totalPrice, 'currency', languageCode) }}

          </span>
          <span v-if="!priceOverriden">
            <small
              v-for="(extra, index) in product.extras"
              :key="index"
            >
              &nbsp;inc. {{ extra.name.trim() }}
            </small>
          </span>
          <del v-if="priceOverriden">
            {{ $n(product.totalPrice, 'currency', languageCode) }}
          </del>
          <del v-if="priceOverriden">
            <small
              v-for="(extra, index) in product.extras"
              :key="index"
            >
              &nbsp;inc. {{ extra.name.trim() }}
            </small>
          </del>
        </div>
        <div
          v-if="product.price || product.price === 0"
          class="ml-3 w-100"
        >
          <span v-if="!priceOverriden">
            {{ $n(product.price, 'currency', languageCode) }}
          </span>
          <span
            v-if="!priceOverriden"
          >
            <small
              v-for="(extra, index) in product.extras"
              :key="index"
            >
              &nbsp;inc. {{ extra.name.trim() }}
            </small>
          </span>
          <del v-if="priceOverriden">
            {{ $n(product.price, 'currency', languageCode) }}
          </del>
          <del
            v-if="priceOverriden"
          >
            <small
              v-for="(extra, index) in product.extras"
              :key="index"
            >&nbsp;inc. {{ extra.name.trim() }}
            </small>
          </del>
        </div>
      </div>
      <div
        v-if="!product.offerLines"
        class="col-md-12 content-list mb-2"
      >
        <div class="col-5" />
        <booking-price-override
          :disabled="disabled"
          :price="product.price"
          class="col"
        />
      </div>

      <div
        v-if="priceOverriden"
        class="col-md-12 content-list mb-2"
      >
        <b>Override Price:</b>
        <div class="ml-3 w-100">
          <span class="font-weight-bold">
            {{ $n(overrideParkingProductPrice, 'currency', languageCode) }}
          </span>
          <span>
            <small
              v-for="(extra, index) in product.extras"
              :key="index"
            >
              &nbsp;inc. {{ extra.name.trim() }}
            </small>
          </span>
        </div>
      </div>
      <div
        v-if="isProductDiscrepant(product.id)"
        class="col-12 small text--error"
      >
        The price of this product has {{ getDiscrepancyById(product.id).type }} by {{ $n(Math.abs(getDiscrepancyById(product.id).reservedPrice - getDiscrepancyById(product.id).oldPrice), 'currency', languageCode) }}
      </div>
    </div>
  </div>
</template>
<script>
import BookingPriceOverride from '../BookingPriceOverride'
import { mapState } from 'vuex'

export default {
    name: 'BookingSummaryProduct',
    components: {
        BookingPriceOverride
    },
    props: ['product', 'discrepancies', 'disabled'],
    computed: {
        ...mapState({
            priceOverriden: state => state.booking.priceOverriden,
            overrideParkingProductPrice: state => state.booking.overrideParkingProductPrice
        }),
        languageCode () {
            var code = this.$store.getters['getLanguageCode']({
                identifier: this.$store.state.airport.selectedAirportId
            })
            if (code !== null) {
                return code
            }
            return 'en-GB'
        }
    },
    methods: {
        isProductDiscrepant (id) {
            return !!this.discrepancies.find((discrepancy) => {
                if (id.toString() === discrepancy.id.toString()) return true
            })
        },
        getDiscrepancyById (id) {
            return this.discrepancies.find((discrepancy) => {
                if (id.toString() === discrepancy.id.toString()) return true
            })
        }
    }
}
</script>
